export default "__VITE_ASSET__BOggF2Xt__"